import api from "../services/mobile-api";

import { useState, useEffect } from "react";

function retornaMensagemDeErro(status) {
  if (status) {
    if (status >= 400 && status < 500) {
      if (status === 408) {
        return (
          "Demorou muito para se conectar com o servidor." +
          " Verigique a sua internet!"
        );
      }
      return "Nenhum dado encontrado!";
    } else if (status >= 500) {
      return "Erro no nosso servidor!";
    }
  } else {
    return (
      "Problema ao tentar conectar com o servidor." +
      " Verifique a sua conexão com a internet!"
    );
  }
}

export const useAxios = (props) => {
  const [response, setResponse] = useState(undefined);
  const [error, setError] = useState(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async (params) => {
      try {
        const result = await api.request(params);
        setResponse(result.data);
        console.log(
          `Requisição realizada com sucesso! \nEndpoint: /api/observatorio${props.url} \nCódigo: ${result.status}`
        );

        if (error) {
          setError(undefined);
        }
      } catch (error) {
        if (response) {
          setResponse(undefined);
        }
        if (error.response) {
          console.log(
            `Requisição falhou \nEndpoint: /api/observatorio${props.url} \nCódigo: ${error.response.status}`
          );
          if (error.response.data.status_mensagem) {
            setError(error.response.data.status_mensagem);
          } else {
            setError(retornaMensagemDeErro(error.response.status));
          }
        } else {
          setError("Erro ao tentar conectar com o servidor.");
          console.log(
            `Requisição falhou \nEndpoint: /api/observatorio${props.url} \nCódigo: ${error}`
          );
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData(props);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.url]);

  return { response, error, loading };
};
